import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { Button, Dropdown, List, Select } from 'tea-component';
import './index.scss'
import { useHistory, useIntl } from 'umi';

export default function DataPreviewLink(props) {
  const history = useHistory();
  const { url = '' } = props
  
  const list = url.split(",")
  const { formatMessage } = useIntl();

  const menu = (close: any) => (
    <List type="option">
      {
        list?.map((item) => {
          const text = item.includes('Mobile') ? 'Mobile' : item.includes('Pc') || item.includes('pc') ? 'Pc' : 'Console'
          return (
            <List.Item onClick={() => { item ? history.push(item) : null }}>
              {text}
            </List.Item>
          )
        })
      }

    </List>
  );

  return (
    <>
      {
        list?.length > 1 ?
          <Dropdown
            className='dbi-sm-dropdown'
            trigger="hover"
            clickClose={false}
            style={{ marginRight: 10 }}
            button={formatMessage({id: 'dbi_data_preview'})}
            appearance="link"
            placement="bottom"
          >
            {menu}
          </Dropdown>
          :
          <Button type="link" onClick={() => history.push(list[0])} >
            {formatMessage({id: 'dbi_data_preview'})}
          </Button>
      }
    </>
  )
}